import { img } from "./helpers";

const highlights = [
  { key: "spot", icon: "spot", label: { JP: "当日ベストな1スポット", EN: "Best spot of the day", 中文: "当天最佳地点", 한국어: "당일 최고의 장소" } },
  { key: "camera", icon: "camera", label: { JP: "一眼レフ撮影", EN: "DSLR photography", 中文: "单反相机拍摄", 한국어: "DSLR 촬영" } },
  { key: "drone", icon: "drone", label: { JP: "ドローン撮影", EN: "Drone photography", 中文: "无人机拍摄", 한국어: "드론 촬영" } },
  { key: "time", icon: "schedule", label: { JP: "最も映える時間に撮影", EN: "Best light of the day", 中文: "最佳光线时段拍摄", 한국어: "가장 아름다운 시간대 촬영" } },
];

const images = [
  img("v1789692027/DSC01001_nqnlup.jpg"),
  img("v1785311449/DSC00588-2_x2m1d1.webp"),
  img("v1785776522/DSC00817_ag3z9t.webp"),
  img("v1783928240/DJI_20260707115904_0007_D_cui3oa.webp"),
  img("v1785311757/IMG_8564_jkfm7r.webp"),
  img("v1785776522/DJI_20260802131800_0033_D_drlb1i.webp"),
  img("v1784940531/DSC00400_ftuhtb.jpg"),
  img("v1785005393/DSC00191_small_lhfvnk.jpg"),
];

const localeText = {
  JP: {
    title: "1スポット撮影",
    pathTitle: "1スポット撮影",
    heroTitle: "1スポット撮影",
    heroDescription: "その日の宮古島で最も映えるビーチと時間を選び、一眼レフとドローンで撮影します",
    time: "1時間",
    startTimes: ["当日の天候に合わせて相談"],
    people: "1名様〜",
    heroPrice: "¥5,000",
    heroPriceNote: "今だけモニター価格 / 税込 / 1名様",
    description: "その日の天気・風・潮位・光の向きを確認し、宮古島で最も映えるビーチを1か所選んで撮影します。約1時間で、一眼レフ写真とドローン写真・映像を旅の思い出として残せます。",
    featureIntro: "場所と時間を固定せず、その日の宮古島が一番きれいに見える条件に合わせてご案内します。短時間で本格的な写真と空撮を残したい方におすすめです。",
    detailItems: [["所要時間", "約1時間"], ["料金", "今だけモニター価格 ¥5,000（税込）/ 1名様"], ["撮影場所", "当日の天候・海況から1スポットを選定"], ["開始時間", "最も映える時間をご案内"], ["最少催行人数", "1名"], ["集合場所", "撮影スポット付近（事前にご案内）"]],
    included: ["一眼レフ撮影", "ドローン撮影", "写真・映像データ"],
    notIncluded: ["衣装・ヘアメイク", "個人的なお買い物"],
    faqs: [
      { question: "送迎はありますか？", answer: "送迎はありません。撮影スポットでの現地集合となります。集合場所は事前にご案内します。" },
      { question: "年齢制限はありますか？", answer: "ツアーの世界観や体験コンセプト維持のため、20歳〜40歳の方を対象とさせていただいております。" },
      { question: "子供も参加できますか？", answer: "申し訳ありません。大人向けの体験・撮影をコンセプトとしているため、お子様のご参加はご遠慮いただいております。" },
      { question: "支払いはいつですか？", answer: "お支払いは当日にお願いいたします。" },
      { question: "雨の日はどうなりますか？", answer: "天候や海況により十分な撮影が難しい場合は、日程変更または中止をご相談します。" },
    ],
    noteColumns: [{ icon: "bag", title: "持ち物", items: ["水着", "タオル", "日焼け止め", "サングラス・帽子"] }],
    priceDescription: "現在は今だけのモニター価格です。参加人数分の料金となります。天候や飛行条件によりドローン撮影ができない場合があります。",
    scheduleItems: [
      { time: "", title: "現地集合", description: "その日最も映えるビーチと時間を指定します", img: [], fullWidth: false },
      { time: "", title: "撮影", description: "一眼カメラでの写真撮影・ドローン映像撮影", img: [], fullWidth: false },
      { time: "", title: "撮影終了・解散", description: "撮ったデータをエアドロップでお渡しします", img: [], fullWidth: false },
    ],
  },
  EN: {
    title: "One-Spot Scenic Photo Tour", pathTitle: "One-Spot Photo Tour", heroTitle: "One-Spot Scenic Photo Tour",
    heroDescription: "A one-hour DSLR and drone shoot at the beach with the best conditions and light that day.",
    time: "1 hour", startTimes: ["Arranged for the best conditions"], people: "1+ guests", heroPrice: "¥5,000", heroPriceNote: "Limited monitor price / tax included / person",
    description: "We check the weather, wind, tide, and light, then select one of Miyakojima's most photogenic beaches for a one-hour DSLR and drone shoot.",
    featureIntro: "The location and time are selected for the day's best light, making this ideal for travelers who want professional photos and aerial footage in a short session.",
    detailItems: [["Duration", "Approx. 1 hour"], ["Price", "Limited monitor price: ¥5,000 tax included / person"], ["Location", "One spot selected for the day's conditions"], ["Start time", "Arranged for the best light"], ["Minimum guests", "1"], ["Meeting point", "Near the selected spot"]],
    included: ["DSLR photography", "Drone photography", "Photo and video data"], notIncluded: ["Costumes and styling", "Personal expenses"],
    faqs: [{ question: "Is pickup available?", answer: "Pickup is not available. Please meet us at the shooting location; details will be sent in advance." }, { question: "Is there an age limit?", answer: "To maintain the concept and atmosphere of the tour, this experience is for guests aged 20 to 40." }, { question: "Can children join?", answer: "Sorry, this experience and photo shoot are designed for adults, so children cannot participate." }, { question: "When do I pay?", answer: "Please pay on the day of the tour." }],
    noteColumns: [{ icon: "bag", title: "What to bring", items: ["Swimwear", "Towel", "Sunscreen", "Sunglasses and hat"] }],
    priceDescription: "This is a limited monitor price. Price is per participant. Drone shooting may be unavailable due to weather or flight restrictions.",
    scheduleItems: [{ time: "", title: "Meet on location", description: "We will specify the day's most photogenic beach and best time in advance.", img: [], fullWidth: false }, { time: "", title: "Photo shoot", description: "DSLR photography and drone video shooting.", img: [], fullWidth: false }, { time: "", title: "Finish", description: "Your data will be transferred via AirDrop.", img: [], fullWidth: false }],
  },
  中文: {
    title: "单景点绝景摄影之旅", pathTitle: "单景点摄影之旅", heroTitle: "单景点绝景摄影之旅",
    heroDescription: "在当天宫古岛最上镜的海滩和最佳时间，用单反相机与无人机拍摄约1小时。",
    time: "1小时", startTimes: ["根据当天最佳条件协商"], people: "1人起", heroPrice: "¥5,000", heroPriceNote: "限时体验价 / 含税 / 每人",
    description: "根据当天的天气、风、潮汐与光线，选择宫古岛最上镜的一处海滩，进行约1小时的单反与无人机拍摄。",
    featureIntro: "不固定地点和时间，按当天最美的光线安排，适合希望短时间留下专业照片和航拍影像的游客。",
    detailItems: [["所需时间", "约1小时"], ["价格", "限时体验价 ¥5,000 含税 / 每人"], ["拍摄地点", "根据当天条件选择1处"], ["开始时间", "安排在最佳光线时段"], ["最少人数", "1人"], ["集合地点", "所选景点附近"]],
    included: ["单反相机拍摄", "无人机拍摄", "照片及视频数据"], notIncluded: ["服装及造型", "个人消费"],
    faqs: [{ question: "提供接送吗？", answer: "不提供接送，请在拍摄地点集合。集合地点会提前通知。" }, { question: "有年龄限制吗？", answer: "为了维持本行程的世界观和体验概念，仅限20岁至40岁的客人参加。" }, { question: "儿童可以参加吗？", answer: "抱歉，本体验及拍摄以成人为对象，儿童不可参加。" }, { question: "什么时候付款？", answer: "请在参加当天付款。" }],
    noteColumns: [{ icon: "bag", title: "携带物品", items: ["泳衣", "毛巾", "防晒霜", "太阳镜和帽子"] }],
    priceDescription: "目前为限时体验价，按参加人数收费。受天气或飞行条件影响，无人机可能无法起飞。",
    scheduleItems: [{ time: "", title: "现场集合", description: "我们会提前指定当天最上镜的海滩和最佳时间。", img: [], fullWidth: false }, { time: "", title: "拍摄", description: "使用单反相机拍照并拍摄无人机视频。", img: [], fullWidth: false }, { time: "", title: "拍摄结束・解散", description: "拍摄数据将通过AirDrop交付。", img: [], fullWidth: false }],
  },
  한국어: {
    title: "원 스팟 절경 촬영 투어", pathTitle: "원 스팟 촬영 투어", heroTitle: "원 스팟 절경 촬영 투어",
    heroDescription: "당일 미야코지마에서 가장 아름다운 해변과 시간대를 골라 DSLR과 드론으로 촬영하는 1시간 투어",
    time: "1시간", startTimes: ["당일 최적 조건에 맞춰 상담"], people: "1명부터", heroPrice: "¥5,000", heroPriceNote: "기간 한정 모니터 가격 / 세금 포함 / 1인",
    description: "당일 날씨, 바람, 조위와 빛을 확인해 미야코지마에서 가장 아름다운 해변 한 곳을 선택하고 약 1시간 동안 DSLR과 드론으로 촬영합니다.",
    featureIntro: "장소와 시간을 고정하지 않고 당일 가장 좋은 빛에 맞춰 안내합니다. 짧은 시간에 전문 사진과 항공 영상을 남기고 싶은 분께 추천합니다.",
    detailItems: [["소요 시간", "약 1시간"], ["요금", "기간 한정 모니터 가격 ¥5,000 / 세금 포함 / 1인"], ["촬영 장소", "당일 조건에 따라 1곳 선정"], ["시작 시간", "가장 아름다운 빛의 시간 안내"], ["최소 인원", "1명"], ["집합 장소", "선정된 장소 인근"]],
    included: ["DSLR 촬영", "드론 촬영", "사진 및 영상 데이터"], notIncluded: ["의상 및 헤어메이크업", "개인 경비"],
    faqs: [{ question: "송영이 있나요?", answer: "송영은 없습니다. 촬영 장소에서 현지 집합하며, 장소는 사전에 안내드립니다." }, { question: "연령 제한이 있나요?", answer: "투어의 분위기와 콘셉트를 유지하기 위해 20세부터 40세까지의 고객님을 대상으로 합니다." }, { question: "어린이도 참가할 수 있나요?", answer: "죄송하지만 성인을 위한 체험과 촬영이므로 어린이는 참가할 수 없습니다." }, { question: "결제는 언제 하나요?", answer: "결제는 투어 당일 부탁드립니다." }],
    noteColumns: [{ icon: "bag", title: "준비물", items: ["수영복", "수건", "선크림", "선글라스・모자"] }],
    priceDescription: "현재 기간 한정 모니터 가격입니다. 참가 인원별 요금이며 날씨 또는 비행 조건에 따라 드론 촬영이 불가능할 수 있습니다.",
    scheduleItems: [{ time: "", title: "현지 집합", description: "당일 가장 아름다운 해변과 시간대를 사전에 안내드립니다.", img: [], fullWidth: false }, { time: "", title: "촬영", description: "DSLR 사진 촬영과 드론 영상 촬영을 진행합니다.", img: [], fullWidth: false }, { time: "", title: "촬영 종료・해산", description: "촬영한 데이터는 AirDrop으로 전달해 드립니다.", img: [], fullWidth: false }],
  },
};

export const oneSpotPhotoTour = {
  id: "oneSpotPhoto",
  slug: "one-spot-photo-tour",
  href: "/tours/one-spot-photo-tour",
  categoryKey: "general",
  cardImage: img("v1789692126/DSC01250-2_pu8x4u.jpg"),
  images,
  tags: ["drone", "camera", "private"],
  time: "1h",
  salePrice: { amount: 5000, unit: "person" },
  detail: {
    heroImage: images[0],
    disableHeroOverlay: true,
    heroYoutubeUrl: "https://www.youtube.com/watch?v=mRwcLL6hzM8",
    isVertical: false,
    showCustomize: false,
    showScheduleImages: false,
    images: images.slice(1),
  },
  detailTexts: Object.fromEntries(Object.entries(localeText).map(([lang, text]) => [lang, {
    ...text,
    highlights,
    price: { title: "Price", subtitle: lang === "JP" ? "料金" : lang === "中文" ? "价格" : lang === "한국어" ? "요금" : "Pricing", list: [{ priceTitle: text.title, price: "¥5,000", priceDescription: text.priceDescription }] },
  }])),
  texts: Object.fromEntries(Object.entries(localeText).map(([lang, text]) => [lang, {
    title: text.title,
    startTimes: text.startTimes,
    people: text.people,
    notes: text.heroDescription,
  }])),
};
